import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import styled from "styled-components"
import { showModal } from "../../../features/modal/modalSlice"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import { useState } from "react"
import moment from "moment/moment"
import { addLoad } from "../../../features/addLoad/addLoadSlice"
import SmallSpinner from "../../shared/spinners/SmallSpinner"
import Btn from "../../shared/button/Btn"
import getKayitliYukDiff from "../../../helper/load/getKayitliYukDiff"
import NumberFormatInput from "../../shared/input/special/NumberFormatInput"
import InputPhoneFormat from "../../shared/input/new/InputPhoneFormat"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 800px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 30px 20px 30px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: ${({theme}) => theme.mainTextColor};

        .project{
            margin-bottom: 30px;
            display: flex;
            flex-direction: column;
            gap: 10px;
            align-items: center;
        }

        p{
            font-size: var(--font-size-lg);
            font-weight: var(--font-weight-lg);
            margin-bottom: 10px;
        }

        .option-list{
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 25px;
            margin-bottom: 20px;
            width: 70%;

            .option-container{
                display: flex;
                flex-direction: column;
                align-items: center;
                width: 100%;
                .load-phone{
                    margin-top: 15px;
                }
                .time-select{
                    width: 100%;
                    display: flex;
                    margin-top: 10px;
                    align-items: center;
                    justify-content: space-between;
                    gap: 10px;
                    .time-title{
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-md);
                    }
                }
                .option{
                    display: flex;
                    align-items: center;
                    width: 100%;
                    color: ${({theme}) => theme.mainTextColor};

                    .option-btn{
                        background-color: ${({theme}) => theme.secondaryBgColor};
                        padding: 15px;
                        border-radius: 10px;
                        border: 2px solid transparent;
                        width: 100%;
                    }
                    
                    .active{
                        border-color: var(--color-main);
                        color: var(--color-main);
                        background-color: ${({ theme }) => theme.mainBgColor};
                    }

                    .question-svg{
                        background-color: ${({theme}) => theme.secondaryBgColor};
                        width: 40px;
                        height: 35px;
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-weight: var(--font-weight-lg);
                        font-size: var(--font-size-lg);
                        cursor: pointer;
                        margin-right: 10px;
                    }

                }
        }
            
        }
         
    }
`
 
const yayinlamaSecenekleri = [
    {
        id:1,
        text: "Herkese Yayınla",
        description:"Tüm KAMYOON üyelerine yayınlanacaktır. Tüm üyeler teklif verebilecektir. Yük için aranacak telefon numarasını giriniz."
    },
    {
        id:2,
        text: "Önce Yük Arayan Araçlarıma - Sonra Herkese Yayınla",
        description:"Önce sürücülerime yayınlanacak; seçtiğiniz saatte tüm Kamyoon üyelerine yayınlanacaktır."
    },
    {
        id:3,
        text: "Yük Arayan Araçlarıma Yayınla",
        description:"Sadece kendi sürücülerime yayınlanacak ve sadece kendi sürücülerim teklif verebilecektir."
    },
    {
        id:4,
        text: "İş Listemde Kalsın",
        description:"Yayınlanmaz. Sadece kendi iş listenizde kalır. Teklif toplayamazsınız. “Herkese Yayınla” seçeneğini tercih etmeniz önerilir."
    }
]

const AddLoadYuklemeSecenekleriModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const {topBarCompanyInfo } = useSelector(state => state.companyProfile)
    const { lockScroll, unlockScroll } = useScrollLock();
    const [activeItem, setActiveItem] = useState({
        id:1,
        text: "Herkese Yayınla",
    })
    const [phone, setPhone] = useState("")
    const [publishTime, setPublishTime] = useState(1)

    const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
    const rld = JSON.parse(storage.getItem("rld"))

    const {route, aracData, paymentData, yukData, paketlemeData, routeDistance, isLoadingAddLoad, selectedProjectAddLoad} = useSelector(state => state.addLoad)

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()
        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    //! boş olan bütün boşaltma tarihleri sonuncu yükleme tarihine göre belirlenir
    // const dateOptions = (item) => {
    //     if (item.locationType === "yukleme") {
    //         return moment(item.date).format('YYYY-MM-DD');
    //     } 
        
    //     else if (item.locationType === "bosaltma" && item.date) {
    //         return moment(item.date).format('YYYY-MM-DD');
    //     } 
        
    //     else if (item.locationType === "bosaltma" && !item.date) {
    //         const lastYukleme = route.filter(item => item.locationType === "yukleme").pop();
    //         return moment(moment(lastYukleme?.date, 'YYYY-MM-DD')).add(1, 'days').format('YYYY-MM-DD');
    //     }
    // };

    //! boş olan bütün boşaltma tarihleri kendinden bir önceki route tarihine göre belirlenir AMA kendinden önceki route un tarihi yoksa sonuncu yükleme tarihine göre belirlenir
    const dateOptions = (item) => {
        const currentIndex = route.indexOf(item); 
    
        if (item.locationType === "yukleme") {
            return moment(item.date).format('YYYY-MM-DD');
        } 
        
        else if (item.locationType === "bosaltma" && item.date) {
            return moment(item.date).format('YYYY-MM-DD');
        } 
        
        else if (item.locationType === "bosaltma" && !item.date) {
            const previousItem = route[currentIndex - 1]; 
            const lastYukleme = route.filter(item => item.locationType === "yukleme").pop();
            if (previousItem.date) {
                return moment(moment(previousItem.date, 'YYYY-MM-DD')).add(1, 'days').format('YYYY-MM-DD');
            }else {
                return moment(moment(lastYukleme.date, 'YYYY-MM-DD')).add(1, 'days').format('YYYY-MM-DD');
            }
        }
    };

    useEffect(() => {
        if (topBarCompanyInfo.yetkiliPhoneNumber) {
            const formattedPhoneNumber = (topBarCompanyInfo.yetkiliPhoneNumber.startsWith("+90") || topBarCompanyInfo.yetkiliPhoneNumber.startsWith("90")) ? `${topBarCompanyInfo.yetkiliPhoneNumber}` : `90${topBarCompanyInfo.yetkiliPhoneNumber}`;
            setPhone(formattedPhoneNumber);
        }
    }, []);
    
    const handleClick = () => {

        if(activeItem.id === 1 && !phone){
            // console.log("telefon numarası girilmeli");
            
        }
        
        const data = {
            //! load
                isParsiyel: yukData?.yuklemeTuru.value,
                loadtype: yukData?.yukTuru,
                isDangerous: yukData?.yukADR,
                dangerousDescription: yukData?.yukAdrDescription,
                loadQuantity: yukData?.agirlikBirim.value === 3 ? 1 : parseInt(yukData?.toplamAgirlik),
                loadUnit: yukData?.agirlikBirim.text,
                loadUnitId: yukData?.agirlikBirim.value,
                loadBulk: parseInt(yukData?.toplamHacim)  || 0,
                loadDescription: yukData?.yukDesc,
                loadValue: parseInt(yukData?.yukunDegeri) || 0,
                companyLoadNumber: yukData?.companyLoadNumber || "",
                customsPlace: yukData?.customsPlace || "",
                vesselDate: yukData?.vesselDate || null,
                isFreeZone: Boolean(yukData?.isFreeZone),
                isInsuranceRequested: false, 

                truckQuantity: parseInt(aracData.aracSayisi),
                usedTruckQuantity: 0,
                truckType: aracData.aracTypeName,
                truckTypeId: aracData.aracTypeId,
                trailerType: aracData.kasaTypeName,
                trailerTypeId: aracData.kasaTypeId,
                groundType: aracData.zeminType.text ? aracData.zeminType.text : "Farketmez",
                groundTypeId: aracData.zeminType.value || 0,
                truckDescription: aracData.digerOzellikler,

                loadOwnerFreight: parseInt(paymentData.yukverenFiyat),
                freightVisibility: paymentData.fiyatYayinlansin,
                freight: parseInt(paymentData.hedefNakliyefiyat)  || 0,
                distance: parseInt(routeDistance)  || 0,
                publishingTypeId: (rld === "ee37e5e8-6aa5-46cd-b718-2dd45e4f0d84" || rld === "3d3aaf05-3ce1-4bfe-95d4-6feae88b1228") ? 4 : (activeItem.id || 1),
                isActive: false,
                isFavorite: false,
                commissionPaymentId: paymentData.komisyonDurumu.value || 0, 
                commissionPayment: paymentData.komisyonMiktari.value === 0 ? 0 : parseInt(paymentData.komisyonMiktari),
                fuelPaymentId: paymentData.yakitDurumu.value || 0,
                fuelPayment:  paymentData.yakitDurumu.value === 0 ? 0 : parseInt(paymentData.yakitOrani),
                paymentType: paymentData.odemeSekli.text,
                paymentTypeId: paymentData.odemeSekli.value,
                paymentUnit: paymentData.fiyatlandirmaType.value,
                otherPaymentDescription: paymentData.odemeSekliDigerAciklama,
                companyProjectId: selectedProjectAddLoad?.id,
                scheduledPublishTimeHours: (activeItem?.id === 2 && (rld !== "ee37e5e8-6aa5-46cd-b718-2dd45e4f0d84" && rld !== "3d3aaf05-3ce1-4bfe-95d4-6feae88b1228")) ? publishTime : null,

                //! yükün yayınlanacağı tel
                phoneNumber: (phone?.startsWith("+90") || phone?.startsWith("90")) ? phone?.slice(2) : phone,

            //! route
            routePoints: route.map((item, i) => {
                return {
                    //! yetkili bilgileri
                    companyName: item?.companyName || "",
                    routePointPersonPhoneNumber: (item.routePointPersonPhoneNumber?.startsWith("+90") || item.routePointPersonPhoneNumber?.startsWith("90")) ? item.routePointPersonPhoneNumber?.slice(2) : item.routePointPersonPhoneNumber || "",
                    mailAddress: item.mailAddress || "",
                    routePointPersonName: item.routePointPersonName || "",
                    smsVerification: item.smsVerification || false,
                    smsVerificationPhoneNumber: (item.smsVerificationPhoneNumber?.startsWith("+90") || item.smsVerificationPhoneNumber?.startsWith("90")) ? item.smsVerificationPhoneNumber?.slice(2) : item.smsVerificationPhoneNumber || "",

                    city: item.locationData.il,
                    town: item.locationData.ilce,
                    address: item.adres,
                    forDirections: item.adresTarif,
                    location: item.locationData.location,
                    locationId: item.locationData?.locationId,
                    //! burada order gelecek, addLoad slice a da eklenmeli
                    order: i+1,
                    loadOrUnload: item.locationType === "yukleme" ? 0 : 1, 


                    lat: item.locationData.lat.toString(),
                    lng: item.locationData.lng.toString(),
                    googleLat: item.locationData.isGoogleAddressSelected ? item.locationData.googleLat : null,
                    googleLng: item.locationData.isGoogleAddressSelected ? item.locationData.googleLng : null,
                    isGoogleAddressSelected: item.locationData.isGoogleAddressSelected,
                    googleAddress: item.locationData.googleLocation ? item.locationData.googleLocation : null,

                    //! bu tarihleri date tipinde yapılacak

                    loadDate: dateOptions(item),
                    lateLoadDate: dateOptions(item),

                    loadTime: item.saatBaslangic,
                    lateLoadTime: item.saatBitis,
                    loadAllTime: item.saatAllTime,
                    isAddressSaved: item.adresKaydedilsinMi,
                    savedAddressName: item.adresBaslik,
                    loadMethods: item.sevkBicimleri.filter((item) => {
                        return item.status
                    }).map(item => {
                        return {name: item.name, methodId: item.id}
                    })
                }
            }),

            packingingTypes: paketlemeData.map(item => {
                return {
                    packagingUnitId: item.activePaketlemeTypeId,
                    olculers: item.list.map(item => {
                        return {
                            en: parseInt(item?.en || 0),
                            boy: parseInt(item?.boy || 0),
                            yukseklik: parseInt(item?.yukseklik || 0),
                            agirlik: parseInt(item?.agirlik || 0),
                            sayisi: parseInt(item?.sayisi || 0),
                            cap: parseInt(item?.cap || 0),
                        }
                    })
                }
            })
        }

        
        dispatch(addLoad({yukData: data, isKayitliYukAsked: getKayitliYukDiff().includes(false)}))
        localStorage.setItem("freightInfo", JSON.stringify(false))

    }
    
  return (
    <Container onClick={()=> dispatch(showModal(null))}>
        <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
                  {(rld !== ("ee37e5e8-6aa5-46cd-b718-2dd45e4f0d84" || "3d3aaf05-3ce1-4bfe-95d4-6feae88b1228")) &&
                <>
                <p>Bir Yayınlama Seçeneği Seçin</p>
                <div className="option-list">
                    {
                        yayinlamaSecenekleri.map((item) => (
                            <div className="option-container">
                                <div className="option">
                                    <button className={item.id === activeItem.id ? "option-btn active" : "option-btn"} onClick={() => setActiveItem(item)}>{item.text}</button>
                                </div>
                                {
                                    item.id === activeItem.id && 
                                    <div style={{display: "flex", paddingTop: "5px"}}>
                                        <div style={{fontSize:"var(--font-size-sm)", fontWeight: "var(--font-weight-md)"}}>{item.description}</div>
                                    </div>
                                }
                                {
                                    activeItem?.id === 1 && item.id === activeItem?.id &&
                                    <div className="load-phone">
                                        <InputPhoneFormat data={phone} setData={setPhone} name={"phone"} inputWidth={"100%"} labelText={"Telefon Numarası"} />
                                    </div>
                                }
                                {
                                    activeItem?.id === 2 && item.id === activeItem?.id &&
                                    <div className="time-select">
                                        <div className="time-title">Yükünüz kaç saat sonra Kamyoon üyelerine yayınlansın? </div>
                                        <NumberFormatInput data={publishTime} setData={setPublishTime} inputWidth={"150px"} labelText={"Saat"} name={"publishTime"} />
                                    </div>
                                }
                            </div>
                        ))
                    }
                </div>
                </>
            }
          
           <Btn handleClick={!isLoadingAddLoad && handleClick} bgColor="#E85446" color="#fff" padding="10px" width={"280px"} >{isLoadingAddLoad ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Yük Eklemeyi Tamamla"}</Btn>

        </div>
    </Container>
  )
}

export default AddLoadYuklemeSecenekleriModal
